import { EVENT, IMAGES } from "@/data/content";
import { SectionHead } from "@/components/landing/Categories";
import { Phone, MapPin, Calendar, Clock } from "lucide-react";

export const Contact = () => (
  <section id="contact" className="relative py-24 px-5 sm:px-8 bg-[#09090B]">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-start">
      <div>
        <SectionHead
          eyebrow="Get In Touch"
          title="Contact & Venue"
          sub="Nominations & registrations are open. Reach our team for any assistance."
        />
        <div className="space-y-3">
          {EVENT.contacts.map((c) => (
            <a
              key={c}
              href={`tel:${c.replace(/\s/g, "")}`}
              className="flex items-center gap-4 p-4 rounded-xl bg-[#18181F] gold-border hover:bg-amber-500/5 transition-all group"
              data-testid={`contact-phone-${c.replace(/\s/g, "")}`}
            >
              <div className="w-11 h-11 rounded-lg gold-gradient-bg flex items-center justify-center">
                <Phone className="w-5 h-5 text-black" />
              </div>
              <span className="font-mono-lux text-lg text-amber-100 group-hover:text-amber-300">
                {c}
              </span>
            </a>
          ))}
        </div>

        <div className="mt-6 p-5 rounded-xl bg-[#18181F] gold-border space-y-3">
          <div className="flex items-center gap-3 text-zinc-200">
            <MapPin className="w-5 h-5 text-amber-400" /> {EVENT.venue}
          </div>
          <div className="flex items-center gap-3 text-zinc-200">
            <Calendar className="w-5 h-5 text-amber-400" /> {EVENT.date}
          </div>
          <div className="flex items-center gap-3 text-zinc-200">
            <Clock className="w-5 h-5 text-amber-400" /> {EVENT.time}
          </div>
        </div>
      </div>

      <div className="rounded-3xl overflow-hidden gold-border">
        <img src={IMAGES.gala_banquet} alt="Venue" className="w-full h-[300px] object-cover" />
        <iframe
          title="venue-map"
          src="https://www.google.com/maps?q=RG+Royal+Hotel+Bangalore&output=embed"
          className="w-full h-[280px] border-0"
          loading="lazy"
        />
      </div>
    </div>
  </section>
);
